<template>
  <div class="softwares-warning-section">
    <Loading v-if="isLoading" type="3" />
    <GenericList
      :dataSet="softwares"
      :binding="binding"
      :columnsMetaData="columnsMetaData"
      :prevPageRequest="prevPage"
      :nextPageRequest="nextPage"
      :noDataMessage="noDataMessage"
      :noDataIcon="noDataIcon"
      :refreshData="{
        initialCountdownTime: countdownTime,
        shouldStartInterval: requestDone
      }"
      @paginateClicked="getAllSoftwaresWarnings"
      @onTimeoutCompleted="getAllSoftwaresWarnings"
      :style="isLoading ? 'display: none !important' : ''"
    >
      <h4 slot="header">{{ "sections.softwaresWarning.title" | i18n }}</h4>
      <GenericPaginationSubHeader
        slot="subheader"
        :from="from"
        :to="to"
        :total="totalSoftwares"
        :text="$i18n.t('sections.historySection.entry')"
      />
    </GenericList>
  </div>
</template>

<script>
import {
  Loading,
  StateCircleColor,
  GenericPaginationSubHeader,
  GenericList
} from "@/components";
/**
 * @description Affiche les bascules d'un logiciel par mois
 * @author Samuel Dube
 * @vue-data {String} noDataMessage - Le message à afficher quand la liste est vide
 * @vue-data {String} noDataIcon - L'icône à afficher quand la liste est vide
 * @vue-data {Object} softwares - Objet JSON de toutes les bascules du logiciel
 * @vue-data {Number} currentPage - Le numéro de la page courrante
 * @vue-data {Number} totalSoftwares - La quantité totale des bascules
 * @vue-data {Number} countdownTime - L'intervalle de temps qu'on désire rafraichir les données
 * @vue-data {Boolean} isLoading - Si la page est en train de charger
 * @vue-data {Boolean} requestDone - Indique si la requête est terminée
 * @vue-data {Number} from - Le n ième logiciel au début de la page courante
 * @vue-data {Number} to - Le n ième logiciel à la fin de la page courante
 * @vue-data {String} nextPage - L'url de la prochaine page dans la pagination
 * @vue-data {String} prevPage - L'url de la précédente page dans la pagination
 * @vue-data {Object} binding - Les données de liaison
 * @vue-data {Array} columnsMetaData - Les données des colonnes
 */
export default {
  components: {
    Loading,
    GenericList,
    GenericPaginationSubHeader
  },
  name: "ListSoftwaresWarningSection",
  data() {
    return {
      noDataMessage: this.$i18n.t(
        "sections.GenericList.softwareNoDataRequiresYourAttention"
      ),
      noDataIcon: "icon thumbs up",
      softwares: [],
      currentPage: 1,
      totalSoftwares: 0,
      countdownTime: 60000, // millisecondes
      isLoading: true,
      requestDone: true,
      from: 0,
      to: 0,
      nextPage: "",
      prevPage: "",
      binding: {
        etat: {
          component: {
            type: StateCircleColor,
            props: p => {
              return {
                state: p.etat
              };
            }
          }
        },
        nom_application: {},
        details: {
          component: {
            type: "router-link",
            props: software => {
              return {
                to: "/softwares/" + software.id
              };
            }
          },
          transform: () => this.$i18n.t("dashboard.details")
        }
      },
      columnsMetaData: [
        {
          name: "",
          class: "col-2 text-break"
        },
        {
          name: "",
          class: "col-7 text-break"
        },
        {
          name: "",
          class: "col-3 text-break text-right"
        }
      ]
    };
  },
  /**
   * @description Effectue une première requête pour injecter l'information dans la composante
   */
  async beforeMount() {
    await this.getAllSoftwaresWarnings();
  },
  methods: {
    /**
     * @description Effectue une requête pour obtenir les informations à afficher dans la composante
     * @param {String} requestedPage L'url de la requête de la page qu'on désire dans la pagination
     */
    async getAllSoftwaresWarnings(requestedPage = "") {
      if (!this.requestDone) {
        return;
      }

      if (requestedPage == "") {
        this.requestDone = false;
      }
      await this.$api
        .getAllSoftwaresWarnings(requestedPage)
        .then(res => {
          this.currentPage = res.data.meta.current_page;
          this.to = res.data.meta.to || 0;
          this.from = res.data.meta.from || 0;
          this.nextPage = res.data.links.next || "";
          this.prevPage = res.data.links.prev || "";
          this.softwares = res.data.data;
          this.totalSoftwares = res.data.meta.total;
        })
        .catch(() => {})
        .finally(() => {
          this.requestDone = true;
          this.isLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.softwares-warning-section {
  min-height: 564px;
}
</style>
